import Vue from 'vue';
import isMobile from 'ismobilejs';
import { SLOTS_FILTER } from './slots.const';

export const slots = {
    state: {
        query: {
            sort: SLOTS_FILTER.SORT_OPTIONS[0],
            filter: {
                tag: null,
                text: null
            }
        }
    },

    mutations: {
        setSlotsSort(state, sort) {
            state.query.sort = sort;
        },

        setSlotsFilter(state, { tag, text }) {
            state.query.filter = { tag, text };
        }
    },

    actions: {
        setSlotsSort({ commit }, sort) {
            commit('setSlotsSort', sort);
        },

        setSlotsFilter({ commit }, { tag, text }) {
            commit('setSlotsFilter', { tag, text });
        }
    },

    getters: {
        slots: (state, getters, rootState) => {
            let category = rootState.games.categories.find(c => c.name === 'slots');
            return category
                ? category.games.map(g => {
                      if (g.isJackpot) g.tags.push(SLOTS_FILTER.TAGS.JACKPOT);
                      if (g.isNew) g.tags.push(SLOTS_FILTER.TAGS.NEW);
                      if (g.isPopular) g.tags.push(SLOTS_FILTER.TAGS.TOP);
                      if (g.subCategory === 'slot') g.tags.push(SLOTS_FILTER.TAGS.SLOT);
                      if (g.subCategory !== 'slot') g.tags.push(SLOTS_FILTER.TAGS.NONSLOT);
                      g.translatedName = g.name || Vue.i18n.translate(`games.${g.provider}.${g.gameId}`);

                      return g;
                  })
                : [];
        },

        queriedSlots: (state, getters) => {
            let slots = [...getters.slots];

            if (isMobile.phone || isMobile.tablet) slots = slots.filter(s => s.tags.indexOf('mobile') > -1);

            if (state.query.filter) {
                if (state.query.filter.tag) slots = slots.filter(s => s.tags.indexOf(state.query.filter.tag) > -1);
                if (state.query.filter.text)
                    slots = slots.filter(
                        s => s.gameId.indexOf(state.query.filter.text.toLowerCase()) > -1 || 
                        s.translatedName.toLowerCase().indexOf(state.query.filter.text.toLowerCase()) > -1
                    );
            }

            if (state.query.sort === SLOTS_FILTER.SORT.ALPHABETICALLY) slots.sort((a, b) => a.gameId.localeCompare(b.gameId));
            // TODO: now ordered by game id -> translated game name
            else if (state.query.sort === SLOTS_FILTER.SORT.POPULARITY) slots.sort((a, b) => b.priority - a.priority);

            return slots;
        }
    }
};



// WEBPACK FOOTER //
// ./skins/xkiosk/components/games-filter/slots.module.js